import axios from 'axios';

const vnpay_info = {
  publish: true,
  merchant: 'SUONM001',
  redirect_url: 'https://pay.vnpay.vn/vpcpay.html',
}

const vnpay_payment_types = [
  {id: 1, title: 'Thanh toán quét mã VNPAY', component: 'VnPayQR', name: 'VnPayQR'},
  {id: 2, title: 'Thẻ ATM/Tài khoản Ngân hàng', component: 'VnPayATM', name: 'VnPayATM'},
  {id: 3, title: 'Thẻ thanh toán quốc tế', component: 'VnPayVISA', name: 'VnPayVISA'},
  {id: 4, title: 'Ví điện tử', component: 'VnPayWallet', name: 'VnPayWallet'},
];


// Shipments
const _shipments = [
  {
    id: 1,
    title: "Đặt giao hàng",
    name: "delivery",
    description: "Giao hàng tận nơi",
    icon: "",
    component: "IconDelivery64"
  },
  {
    id: 2,
    title: "Đặt Pickup",
    name: "pickup",
    description: "Nhận hàng tại cơ sở của Sườn Mười",
    icon: "",
    component: "IconPickup64"
  },
];

export default {
  // Restaurants
  async getRestaurants(cb) {
    let list = [];
    let {restapi, pos_data} = window.wzFoodbookData
    if (!restapi || !pos_data) return;
    // console.log(pos_data)
    //
    // let pos_ids = pos_data.map(item => item.Id)
    // for (let id of pos_ids) {
    //   let p = await axios.get(restapi + `/products?pos_id=${id}`)
    //     .then(response => response.data.data)
    //
    //   if (p) {
    //
    //   }
    //   list.push(p)
    // }
    // console.log(list)
    return cb(pos_data)
  },
  async getRestaurant(id, cb) {
    let {restapi} = window.wzFoodbookData

    let rs = await axios.get(restapi + `/products?pos_id=${id}`)
          .then(response => response.data.data)

    return cb(rs)

  },

  // Shipments
  getShipments(cb) {
    return cb(_shipments);
  },

  getPayments(cb) {
    let {restapi, pos_data} = window.wzFoodbookData || {}
    if (!restapi || !pos_data) return;

    axios.get(restapi + '/list_payment')
      .then(function (response) {
        let ListPayment = [
          {id: 1, title: 'Thanh toán bằng tiền mặt khi nhận hàng', description: '', type: "COD"},
        ];
        //console.log(response);
        if (response.data) {
          const {
            wzFoodbook_vnpay_enable,
            wzFoodbook_momo_enable,
            wzFoodbook_zalopay_enable,
          } = response.data

          if (wzFoodbook_vnpay_enable === "1") {
            ListPayment.push({
              id: 2,
              title: 'Thanh toán trực tuyến qua Cổng thanh toán VNPAY',
              description: '(Chấp nhận thẻ ngân hàng nội địa, thẻ Visa/MasterCard)',
              type: "VnPay",
              children: vnpay_payment_types,
              info: vnpay_info
            });
          }

          if (wzFoodbook_momo_enable === "1") {
            ListPayment.push({
              id: 3,
              title: 'Thanh toán Qua MOMO',
              description: 'Chấp nhận thanh toán qua Momo',
              type: "MOMO"
            });
          }

          if (wzFoodbook_zalopay_enable === "1") {
            ListPayment.push({
              id: 4,
              title: 'Thanh toán Qua ZaloPay',
              description: 'Chấp nhận thanh toán qua ZaloPay',
              type: "ZaloPay"
            })
          }

        }
        return cb(ListPayment);
      })
      .catch(function (error) {
        return cb(ListPayment);
      });

  },


}



// WEBPACK FOOTER //
// ./src/api/shop.js